import React from 'react';
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';

import Icon from '../../ui/elements/Icon';

class PriceListMailingStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      priceListMailing: this.props.priceListMailing,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();

    if (this.state.isSubmiting) {
      return;
    }

    if (
      this.state.priceListMailing.status === 'blocked' &&
      !confirm('Вы действительно хотите разблокировать рассылку прайс-листов?')
    ) {
      return;
    }

    this.setState({ isSubmiting: true }, () => {
      const data = new FormData();
      switch (this.state.priceListMailing.status) {
        case 'paused':
          data.append('price_list_mailing[status]', 'active');
          break;
        case 'active':
          data.append('price_list_mailing[status]', 'paused');
          break;
        case 'blocked':
          data.append('price_list_mailing[status]', 'active');
          break;
      }

      fetch(`/office/price_list_mailings/${this.state.priceListMailing.id}.json?only_status=1`, {
        body: data,
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': Rails.csrfToken() },
        method: 'PATCH',
      })
          .then(function(response) {
            if (response.status >= 200 && response.status < 300) {
              return response.json();
            } else {
              const error = new Error(response.statusText);
              error.response = response;
              throw error;
            }
          })
          .then((data) => {
            this.setState({ isSubmiting: false, priceListMailing: data });
          })
          .catch((error) => {
            this.setState({ isSubmiting: false });
            alert('Произошла ошибка при попытке изменить статус рассылки прайс-листа.');
          });
    });
  }

  render() {
    switch (this.state.priceListMailing.status) {
      case 'paused':
        return (
          <a
            href={`/office/price_list_mailings/${this.state.priceListMailing.id}/edit`}
            title="Возобновить рассылку прайс-листа"
            onClick={this.handleClick}
          >
            <Icon
              className={`has-text-warning ${this.state.isSubmitting && 'fa-pulse'}`}
              icon={this.state.isSubmitting ? 'fa-spinner' : 'pause'}
            />
          </a>
        );
      case 'active':
        return (
          <a
            href={`/office/price_list_mailings/${this.state.priceListMailing.id}/edit`}
            title="Приостановить рассылку прайс-листа"
            onClick={this.handleClick}
          >
            <Icon
              className={`has-text-success ${this.state.isSubmitting && 'fa-pulse'}`}
              icon={this.state.isSubmitting ? 'fa-spinner' : 'play'}
            />
          </a>
        );
      case 'blocked':
        return (
          <a
            href={`/office/price_list_mailings/${this.state.priceListMailing.id}/edit`}
            title="Разблокировать рассылку прайс-листа"
            onClick={this.handleClick}
          >
            <Icon
              className={`has-text-danger ${this.state.isSubmitting && 'fa-pulse'}`}
              icon={this.state.isSubmitting ? 'fa-spinner' : 'stop'}
            />
          </a>
        );
    }
  }
}

PriceListMailingStatus.propTypes = {
  priceListMailing: PropTypes.object,
};

export default PriceListMailingStatus;
